import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useSelector } from "react-redux";
import { BusinessStatusCssClasses } from "../BusinessesUIHelpers";
import { useBusinessesUIContext } from "../BusinessesUIContext";

const selectedBusinesses = (entities, ids) => {
  const _businesses = [];
  ids.forEach((id) => {
    const business = entities.find((el) => el.id === id);
    if (business) {
      _businesses.push(business);
    }
  });
  return _businesses;
};

export function BusinessesFetchDialog({ show, onHide }) {
  // Businesses UI Context
  const businessesUIContext = useBusinessesUIContext();
  const businessesUIProps = useMemo(() => {
    return {
      ids: businessesUIContext.ids,
      queryParams: businessesUIContext.queryParams,
    };
  }, [businessesUIContext]);

  // Businesses Redux state
  const { businesses } = useSelector(
    (state) => ({
      businesses: selectedBusinesses(state.businesses.entities, businessesUIProps.ids),
    }),
    shallowEqual
  );

  // if there weren't selected ids we should close modal
  useEffect(() => {
    if (!businessesUIProps.ids || businessesUIProps.ids.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessesUIProps.ids]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Fetch selected elements
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="list-timeline list-timeline-skin-light padding-30">
          <div className="list-timeline-items">
            {businesses.map((business) => (
              <div className="list-timeline-item mb-3" key={business.id}>
                <span className="list-timeline-text">
                  <span
                    className={`label label-lg label-light-${
                      BusinessStatusCssClasses[business.status]
                    } label-inline`}
                    
                  >
                    ID: {business.id}
                  </span>{" "}
                  <span className={`label label-lg label-light-${
                      BusinessStatusCssClasses[business.status]
                    } label-inline`}>
                    name : {business.name}
                  </span>
                </span>
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-primary btn-elevate"
          >
            Ok
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
